import React from 'react';
import { motion } from 'framer-motion';
import { X, Check, AlertTriangle } from 'lucide-react';
export function SalesLetterSection() {
  const frustrations = ['Compras semillas y plantines que se mueren a las dos semanas.', 'No sabes qué plantar en cada época y terminas con macetas vacías.', 'Las plagas se comen tu esfuerzo antes de que puedas cosechar.', 'Sientes que necesitas un patio gigante para tener una huerta real.', 'Te frustra ver fotos de huertas perfectas mientras la tuya apenas sobrevive.'];
  const reasons = [{
    title: 'Falta de Planificación',
    desc: 'Plantar por impulso sin entender los ciclos de la naturaleza es la receta para el fracaso.'
  }, {
    title: 'Suelo Pobre',
    desc: 'Si la tierra no tiene los nutrientes correctos, ni la mejor semilla del mundo va a prosperar.'
  }, {
    title: 'Desconocimiento de Plagas',
    desc: 'Atacar los insectos cuando ya invadieron es tarde. El secreto es la prevención.'
  }];
  const benefits = ['Un calendario exacto de qué sembrar mes a mes en tu región.', 'Técnicas de suelo vivo para que tus plantas crezcan fuertes y sanas.', 'Estrategias de control de plagas 100% naturales y sin venenos.', 'Diseños de huerta para espacios pequeños (balcones, patios, terrazas).', 'El paso a paso para cosechar tus propias ensaladas en 30 días.'];
  return <section className="py-20 px-4 bg-black overflow-hidden" data-id="element-156">
      <div className="max-w-3xl mx-auto space-y-24" data-id="element-157">
        {/* Apertura: Frustraciones */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="space-y-8" data-id="element-158">
          <h2 className="text-3xl font-bold text-white text-center mb-10" data-id="element-159">
            ¿Te suena familiar alguna de estas situaciones?
          </h2>
          <ul className="space-y-4" data-id="element-160">
            {frustrations.map((item, i) => <li key={i} className="flex items-start gap-4 p-4 rounded-lg bg-zinc-900/50 border border-zinc-800" data-id="element-161">
                <div className="p-1 bg-red-900/20 rounded-full mt-0.5" data-id="element-162">
                  <X className="w-5 h-5 text-red-500" data-id="element-163" />
                </div>
                <span className="text-zinc-300 text-lg" data-id="element-164">{item}</span>
              </li>)}
          </ul>

          <div className="border-l-4 border-green-500 pl-6 py-2 my-12" data-id="element-165">
            <p className="text-xl sm:text-2xl font-medium text-white italic" data-id="element-166">
              "Intenté tres veces tener mi huerta. Gasté dinero en tierra,
              macetas y semillas. Todo se secó. Pensé que yo no tenía 'mano
              verde'."
            </p>
          </div>
        </motion.div>

        {/* Agitación: Razones */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="space-y-8" data-id="element-167">
          <h3 className="text-2xl font-bold text-green-400 uppercase tracking-wide text-center" data-id="element-168">
            ¿Por qué falla el 90% de las huertas caseras?
          </h3>
          <div className="grid gap-6" data-id="element-169">
            {reasons.map((reason, i) => <div key={i} className="flex gap-6 items-start" data-id="element-170">
                <span className="flex-shrink-0 w-12 h-12 rounded-full bg-zinc-900 border border-green-500/30 text-green-500 font-bold text-xl flex items-center justify-center" data-id="element-171">
                  {i + 1}
                </span>
                <div data-id="element-172">
                  <h4 className="text-xl font-bold text-white mb-2" data-id="element-173">
                    {reason.title}
                  </h4>
                  <p className="text-zinc-400" data-id="element-174">{reason.desc}</p>
                </div>
              </div>)}
          </div>
        </motion.div>

        {/* Reencuadre */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="relative p-8 rounded-2xl bg-zinc-900 border border-zinc-800" data-id="element-175">
          <div className="absolute top-0 left-0 w-1 h-full bg-zinc-700 rounded-l-2xl" data-id="element-176" />
          <h3 className="text-3xl font-bold text-white mb-6" data-id="element-177">
            El problema no eres tú.
          </h3>
          <p className="text-lg text-zinc-300 mb-6" data-id="element-178">
            Hasta ahora, dependías de consejos sueltos de internet, de la suerte
            o del clima. Nadie te dio un sistema integral.
          </p>
          <p className="text-lg text-zinc-300" data-id="element-179">
            La "mano verde" no existe. Lo que existe es el conocimiento
            aplicado. Y eso es exactamente lo que te falta para tener éxito.
          </p>
        </motion.div>

        {/* Descubrimiento & Presentación */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="rounded-3xl overflow-hidden border border-green-500/30 bg-zinc-900 shadow-2xl shadow-green-900/10" data-id="element-180">
          <div className="bg-gradient-to-r from-green-600 to-green-800 p-6 text-center" data-id="element-181">
            <h3 className="text-2xl font-bold text-white" data-id="element-182">
              PRESENTAMOS LA SOLUCIÓN DEFINITIVA
            </h3>
          </div>

          <div className="p-8 sm:p-12 text-center" data-id="element-183">
            <h2 className="text-4xl sm:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-green-400 to-green-600 mb-10" data-id="element-184">
              HUERTA PRODUCTIVA 360°
            </h2>

            <p className="text-xl text-zinc-300 mb-12 max-w-2xl mx-auto" data-id="element-185">
              El manual digital más completo para transformar cualquier espacio
              en una fuente de alimento real, saludable y sostenible.
            </p>

            <ul className="text-left space-y-6 max-w-xl mx-auto" data-id="element-186">
              {benefits.map((benefit, i) => <li key={i} className="flex items-start gap-4" data-id="element-187">
                  <div className="p-1 bg-green-500/20 rounded-full mt-1" data-id="element-188">
                    <Check className="w-5 h-5 text-green-500" data-id="element-189" />
                  </div>
                  <span className="text-zinc-200 text-lg" data-id="element-190">{benefit}</span>
                </li>)}
            </ul>
          </div>
        </motion.div>
      </div>
    </section>;
}